"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentQuestionTable = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const account_1 = require("../../../base/account");
const featureFlags_1 = require("../../../../common/featureFlags");
const AttachFileAnswer_1 = require("./AttachFileAnswer");
const AudioPlayer_1 = require("./AudioPlayer");
const DetailQuestionStyled = styled_components_1.default.div `
	${props => (props.$isMobile ? mobileStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	display: flex;
	flex-direction: column;
	gap: 12px;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	flex-shrink: 0;
	position: relative;
	height: 100%;

	/* .fext-field {
		height: 100%;
		overflow: hidden;
	} */

	.task-label {
		width: 100%;
	}

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b1-font-size, 20px);
				line-height: var(--b1-line-height, 42px);
				font-weight: var(--b1-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}

	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			gap: 6px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			.input_answer_wrapper {
				background: #ffffff;
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px;
				padding: 4px 10px 4px 10px;
				display: flex;
				flex-direction: row;
				gap: 6px;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: relative;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}

			.body-item {
				width: 100%;
			}

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 12px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}
	}
	.input_point_wrapper {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 10px;
		display: flex;
		flex-direction: row;
		gap: 6px;
		align-items: center;
		justify-content: center;
		position: relative;
		max-width: 80px;
		height: 38px;

		input {
			width: 100%;
			outline: none !important;
			border: none !important;
			padding: 0 !important;
			background: transparent;
		}
	}

	.detail_txt {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}

	.subject-item-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.subject-item-title {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 600;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	.omr-point-wrap {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
	}

	.submission-header {
		gap: 24px;
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.attachment-explain {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-direction: row;
	}

	.attachment-wrapper {
		flex: 1;
		width: 100%;
		box-sizing: border-box;
		gap: 12px;
	}

	.attachment-display {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
	}

	.attachment-question-wrap {
		min-width: 695px;
		width: 695px;
		height: 100%;
		overflow: hidden;

		/* .fext-field {
			height: 100%;
			overflow: hidden;
		} */
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	gap: 21px;
	align-items: flex-end;
	justify-content: flex-start;
	align-self: stretch;
	flex: 1;
	position: relative;
	${props => props.$isDesktop &&
    `
		padding-top: 20px;
		border-top: 1px solid #e6e8ed;
	`}

	/* .fext-field {
		height: 100%;
		overflow: hidden;
	} */

	.task-label {
		width: 100%;
	}

	.no-question-wrap {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		width: 100%;
		height: 100%;

		.fext-field {
			display: flex;
			flex-direction: column;
			gap: 8px;
			align-items: center;
			justify-content: center;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b1-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b1-font-size, 20px);
				line-height: var(--b1-line-height, 42px);
				font-weight: var(--b1-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}
	}

	.task-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			.input_answer_wrapper {
				background: #ffffff;
				border-radius: 4px;
				border-style: solid;
				border-color: var(--color-grey-w, #b6bac0);
				border-width: 1px;
				padding: 4px 10px 4px 10px;
				display: flex;
				flex-direction: row;
				gap: 6px;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;
				position: relative;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				font-weight: var(--b4-font-weight, 400);
				position: relative;
			}

			color: var(--color-black, #101010);
			text-align: center;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
		}
	}
	.input_point_wrapper {
		background: #ffffff;
		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		padding: 4px 10px 4px 10px;
		display: flex;
		flex-direction: row;
		gap: 6px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		overflow: hidden;

		input {
			width: 100%;
			outline: none !important;
			border: none !important;
			padding: 0 !important;
			background: transparent;
		}
	}

	.detail_txt {
		color: var(--color-grey, #666666);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 16px;
		// line-height: 32px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}

	.attachment-explain {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-direction: row;
	}

	.attachment-wrapper {
		flex: 1;
		width: 100%;
		box-sizing: border-box;
		gap: 12px;
	}

	.attachment-display {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
	}

	.attach-file-answer {
		width: 100%;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		gap: 12px;
	}

	.attachment-question-wrap {
		min-width: 695px;
		width: 695px;
		height: 100%;
		overflow: hidden;

		/* .fext-field {
			height: 100%;
			overflow: hidden;
		} */
	}
`;
const count = 100;
exports.AttachmentQuestionTable = react_1.default.memo(({ item, isTest, isSubmit, isOpen, test_id, answerData, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [page, setPage] = (0, react_1.useState)(0);
    const [submittedFileList, setSubmittedFileList] = (0, react_1.useState)([]);
    const [attachFileList, setAttachFileList] = (0, react_1.useState)([]);
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    const submitAnswerMutation = (0, react_query_1.useMutation)(server_1.postSubmitAnswer);
    // 제출 진행 중 재진입 방지(더블클릭/이중 탭 이중 발사 차단) — 동기 ref 가드
    // 파일 업로드(postAttachment) 이중 실행까지 함께 차단한다
    const isSubmittingRef = react_1.default.useRef(false);
    const { data, refetch } = (0, server_1.useQuestionList)({
        test_id,
        offset: page === 0 ? 0 : page * 100,
        limit: 100,
        orderby: ['number'],
    });
    const throttledRefetch = (0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        throttledRefetch();
    }, [page, test_id]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { items } = data;
            setTestData(items);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        setSubmittedFileList(answerData.items.map(item => item.value));
    }, [answerData]);
    const onSubmit = async () => {
        // 제출 진행 중이면 무시 — 더블클릭/이중 탭으로 인한 중복 POST 차단
        if (isSubmittingRef.current)
            return;
        isSubmittingRef.current = true;
        try {
            let values = [];
            if (attachFileList.length === 0) {
                alert('답변 파일을 업로드해주세요.');
                return;
            }
            for (let i = 0; i < attachFileList.length; i++) {
                const file = attachFileList[i];
                if (!file || !file.name) {
                    continue;
                }
                const filepath = `${testData[0].id}/answer/${i + 1}`;
                const value = `/api/mimac/file/${filepath}/${file.name}`;
                await (0, server_1.postAttachment)(file, filepath);
                values.push(value);
            }
            await submitAnswerMutation.mutateAsync({
                id: test_id,
                props: {
                    answers: [
                        {
                            question_id: testData[0].id,
                            values: values,
                        },
                    ],
                    subject_items: [],
                },
            });
            APP.eventManager.publish('ANSWER_REFETCH');
        }
        catch (error) {
            alert(error);
        }
        finally {
            // 성공/실패/검증 중단 모두에서 해제 — 이후의 정상 재제출 허용
            isSubmittingRef.current = false;
        }
    };
    return (react_1.default.createElement(DetailQuestionStyled, { "$isDesktop": isDesktop, "$isMobile": isMobile, "$isTablet": isTablet, className: "field-global-001 attachment-question-wrap" },
        react_1.default.createElement("div", { className: "flex column attachment-wrapper" },
            featureFlags_1.MP3_FEATURE_ENABLED &&
                (item?.attachments || [])
                    .filter((f) => typeof f === 'string' && f.toLowerCase().endsWith('.mp3'))
                    .map((f, i) => (react_1.default.createElement(AudioPlayer_1.AudioPlayer, { key: `audio-${i}`, src: f, fileName: f.split('/').pop() }))),
            isOpen &&
                (isSubmit ? (react_1.default.createElement("div", { className: "attachment-display" },
                    react_1.default.createElement(AttachFileAnswer_1.AttachFileAnswer, { isTeacher: isTeacher, showRegist: !isSubmit, isRegist: !isSubmit, attachFileList: submittedFileList }))) : (react_1.default.createElement("div", { className: "attachment-display" },
                    react_1.default.createElement(AttachFileAnswer_1.AttachFileAnswer, { isTeacher: isTeacher, showRegist: !isSubmit, isRegist: !isSubmit, attachFileList: attachFileList, setAttachFileList: setAttachFileList }))))),
        isTest ? null : !isMobile && isOpen && !isSubmit ? (react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "common.submit", onClick: onSubmit })) : null,
        isTest
            ? null
            : isMobile && (react_1.default.createElement("div", { className: "submission-header" },
                isOpen && !isSubmit && (react_1.default.createElement(common_1.Button, { className: "btn_grey full", text: "common.submit", onClick: onSubmit })),
                !isMobile && (react_1.default.createElement("div", { className: "submission-title" }, t('assignment.detailQuestions')))))));
});
